import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { useTranslation } from '../../../src/i18n';
import TextField from '../../Fields/TextField';
import { TP, urlRegex } from '../../../constants/consts';
import Button from '../../Button';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  errorMessage: {
    position: 'absolute',
    bottom: '-20px',
  },
}));

const AddFieldWithButton = ({
  className,
  id,
  value,
  onChange,
  validateRegex,
  onAdd,
  isLoading,
  errorMessage,
  placeholder,
  label,
  autoFocus,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isValueValid = () => (value.length ? validateRegex.test(value) : true);

  return (
    <div className={cn(classes.root, className)}>
      <TextField
        id={id}
        placeholder={t(placeholder)}
        label={t(label)}
        value={value}
        onChange={e => {
          onChange(e.target.value);
        }}
        autoFocus={autoFocus}
        error={!isValueValid()}
        helperText={isValueValid() ? '' : t(errorMessage)}
        FormHelperTextProps={{ className: classes.errorMessage }}
      />
      <Button
        style={{ height: 46, marginTop: 'auto' }}
        onClick={() => onAdd(value)}
        isLoading={isLoading}
        disabled={!isValueValid() || value?.length === 0}
      >
        {t(`${TP}.m_ADD`)}
      </Button>
    </div>
  );
};

AddFieldWithButton.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  validateRegex: PropTypes.instanceOf(RegExp),
  onAdd: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  autoFocus: PropTypes.bool,
  isLoading: PropTypes.bool,
};

AddFieldWithButton.defaultProps = {
  className: '',
  isLoading: false,
  id: 'add-field',
  validateRegex: urlRegex,
  placeholder: '',
  label: `${TP}.FN_INSERT_WEBLINK`,
  errorMessage: `${TP}.FN_WEB_LINK_INVALID`,
  autoFocus: false,
};

export default memo(AddFieldWithButton);
